export default __webpack_public_path__ + "static/media/icon4.3228cbb4.svg";